import { render } from "./CountryPlansList.vue?vue&type=template&id=4638f8db&scoped=true"
import script from "./CountryPlansList.vue?vue&type=script&lang=js"
export * from "./CountryPlansList.vue?vue&type=script&lang=js"

import "./CountryPlansList.vue?vue&type=style&index=0&id=4638f8db&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4638f8db"]])

export default __exports__